module.exports = __webpack_public_path__ + "static/media/icon.6c535c0e.png";